import type { Card, ColumnId, SortState } from '../data/types';
import { CARDS, BASE_CARDS, ADVANCED_CARDS } from '../data/cards';
import { SORT_COLUMNS } from '../data/types';

export function cardsInColumn(sort: SortState, col: ColumnId, deck: Card[]): Card[] {
  return deck.filter((c) => sort[c.id] === col);
}

export function sortToMarkdown(sort: SortState, title: string, deck: Card[] = CARDS): string {
  const lines: string[] = [];
  lines.push(`# ${title}`);
  lines.push('');
  for (const col of SORT_COLUMNS) {
    const items = cardsInColumn(sort, col.id, deck);
    if (items.length === 0) continue;
    lines.push(`## ${col.label}`);
    lines.push('');
    for (const c of items) lines.push(`- **${c.name}** — ${c.description}`);
    lines.push('');
  }
  lines.push('---');
  lines.push(`*composed on ${new Date().toLocaleDateString()}*`);
  return lines.join('\n');
}

export function sortToText(sort: SortState, title: string, deck: Card[] = CARDS): string {
  const lines: string[] = [];
  lines.push(title.toUpperCase());
  lines.push('');
  for (const col of SORT_COLUMNS) {
    const items = cardsInColumn(sort, col.id, deck);
    if (items.length === 0) continue;
    lines.push(col.label.toUpperCase());
    lines.push('');
    for (const c of items) lines.push(`  • ${c.name} — ${c.description}`);
    lines.push('');
  }
  lines.push(`composed on ${new Date().toLocaleDateString()}`);
  return lines.join('\n');
}

export function downloadFile(filename: string, content: string, mime: string) {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  }
  return false;
}

export function activeDeck(includeAdvanced: boolean): Card[] {
  return includeAdvanced ? CARDS : BASE_CARDS;
}

export { BASE_CARDS, ADVANCED_CARDS };
